import type { FC, ReactNode } from 'react'

import { useRef } from 'react'
import { useEntrance } from '@/components/motion/reveal'
import { SplitWords } from '@/components/motion/split-text'
import RollingNumber from '@/components/motion/rolling-number'
import Img from '@/components/generals/img'
import { editorial } from '@/constants/media'

const AboutHero: FC = (): ReactNode => {
    const root = useRef<HTMLElement>(null)

    useEntrance(root, timeline => {
        timeline
            .from('[data-ab-surface]', { scale: 1.15, duration: 2.4, ease: 'expo.out' }, 0)
            .from('[data-ab-meta]', { autoAlpha: 0, y: 12, duration: 1 }, 0.1)
            .from('[data-ab-est]', { autoAlpha: 0, y: 30, duration: 1.2 }, 0.2)
            .from('[data-ab-statement] .mask > span', { yPercent: 140, duration: 1.2, stagger: 0.04 }, 0.6)
    })

    return (
        <section
            ref={root}
            aria-labelledby='about-title'
            className='relative flex min-h-[100svh] flex-col justify-end overflow-hidden pb-16 pt-[var(--header-height)] md:pb-20'
        >
            <div data-ab-surface className='absolute inset-0'>
                <Img src={editorial.aboutHero} alt='' sizes='100vw' preload className='opacity-90' />            </div>

            <div aria-hidden='true' className='pointer-events-none absolute inset-0 bg-linear-to-t from-ink via-ink/60 to-ink/30' />

            <div className='pointer-events-none relative gutter'>
                <p data-ab-meta className='label-mono'>
                    (About) — The studio
                </p>

                <h1 id='about-title' className='mt-6 flex items-end gap-[0.04em]'>
                    <span data-ab-est className='mb-[0.12em] font-serif text-[clamp(40px,5.4vw,88px)] italic leading-none text-bone'>
                        Est.
                    </span>

                    <span data-ab-est className='font-heading text-[clamp(100px,18vw,300px)] leading-[0.8] text-bone'>
                        <RollingNumber value='2019' trigger='enter' className='font-heading' />
                    </span>
                </h1>

                <p data-ab-statement className='mt-6 max-w-[22ch] font-heading text-[clamp(28px,3.4vw,54px)] uppercase leading-[0.95] text-bone md:mt-8'>
                    <SplitWords text='A small studio making very few, very heavy things.' />
                </p>
            </div>
        </section>
    )
}

export default AboutHero
